import { defineStore } from 'pinia';

export const useUserStore = defineStore('user', {
  state: () => ({
    user: null,
    token: null,
    isAuthenticated: false
  }),
  
  getters: {
    isLoggedIn: (state) => state.isAuthenticated && state.user !== null,
    
    // 獲取用戶ID
    userId: (state) => state.user?.customer_id || null,
    
    // 獲取用戶名
    username: (state) => state.user?.username || '',
    
    // 獲取用戶餘額
    balance: (state) => state.user?.balancepoints || 0
  },
  
  actions: {
    setUser(user) {
      this.user = user;
      this.isAuthenticated = true;
      
      // 不再設置 ordersong 的 localStorage，統一使用主系統認證
      console.log('✅ ordersong 用戶狀態已更新，但不設置 localStorage');
    },
    
    setToken(token) {
      this.token = token;
      
      // 不再設置 ordersong 的 localStorage，統一使用主系統認證
      console.log('✅ ordersong token 已更新，但不設置 localStorage');
    },
    
    logout() {
      this.user = null;
      this.token = null;
      this.isAuthenticated = false;
      
      // 不再清除 ordersong 的 localStorage，統一使用主系統認證
      console.log('✅ ordersong 用戶已登出，但不清除 localStorage');
    },
    
    initializeFromStorage() {
      // 清除舊的 ordersong localStorage 數據，統一使用主系統認證
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      console.log('ℹ️ 已清除舊的 ordersong localStorage 數據，統一使用主系統認證');
      
      // 統一從主系統的 localStorage 讀取認證狀態
      const mainSystemUser = localStorage.getItem('user_info');
      const mainSystemToken = localStorage.getItem('auth_token');
      
      if (mainSystemUser && mainSystemToken) {
        try {
          const userData = JSON.parse(mainSystemUser);
          
          // 轉換為 ordersong 格式的用戶數據
          const ordersongUserData = {
            customer_id: userData.customer_id || userData.id?.toString(),
            username: userData.username,
            email: userData.email,
            balancepoints: userData.balance_points || 0
          };
          
          this.user = ordersongUserData;
          this.token = mainSystemToken;
          this.isAuthenticated = true;
          
          console.log('✅ 從主系統初始化 ordersong 用戶狀態:', ordersongUserData);
        } catch (e) {
          console.error('❌ 無法解析主系統用戶信息:', e);
        }
      } else {
        console.log('ℹ️ 主系統沒有認證狀態');
      }
      
      console.log('🔍 ordersong 用戶狀態初始化完成:', {
        isAuthenticated: this.isAuthenticated,
        user: this.user,
        hasToken: !!this.token
      });
    }
  }
}); 